import { create } from "zustand";
import { persist } from "zustand/middleware";

export const useUserStore = create()(
  // persist(
  (set) => ({
    onboardingPath: null,
    setOnboardingPath: (path) => set({ onboardingPath: path }),

    reset: () =>
      set({
        onboardingPath: null,
      }),
  }),
  {
    name: "user-storage", // unique name for localStorage
    // partialize: (state) => ({
    //   onboardingPath: state.onboardingPath,
    // }),
  }
  // )
);
